<template>
  <section class="cms-body">
    <el-form
      ref="form"
      :model="dataInfo"
      :rules="rules"
      class="cms-form"
      label-width="162px"
    >
      <el-form-item label="用户名" class="flex-50" prop="user_name">
        <el-input v-model="dataInfo.user_name"></el-input>
      </el-form-item>
      <el-form-item label="用户标识" class="flex-50" prop="user_code">
        <el-input v-model="dataInfo.user_code"></el-input>
      </el-form-item>
      <el-form-item label="用户性别" class="flex-50">
        <el-radio-group v-model="dataInfo.user_gender">
          <el-radio :label="'0'">女</el-radio>
          <el-radio :label="'1'">男</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="密码" class="flex-50" prop="user_pwd">
        <el-input v-model="dataInfo.user_pwd" type="password"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" class="flex-50" prop="confirmPassword">
        <el-input v-model="dataInfo.confirmPassword" type="password"></el-input>
      </el-form-item>

      <el-form-item label="用户角色" class="flex-50" prop="rid">
        <el-radio-group v-model="dataInfo.rid" :disabled="true">
          <el-radio v-for="item in roles" :key="item.rid" :label="item.rid">
            {{item.role_name}}
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="用户状态" class="flex-50" prop="user_status">
        <el-radio-group v-model="dataInfo.user_status" :disabled="true">
          <el-radio :label="'0'">停用</el-radio>
          <el-radio :label="'1'">在用</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="所属用户" class="flex-50" prop="user_owner" v-show="String(dataInfo.rid)!=='1'">
        <el-select v-model="dataInfo.user_owner" :disabled="true">
          <template v-for="item in users">
            <el-option
            v-if="String(item.uid)!==String($store.state.userInfo.id)"
            :key="item.uid"
            :label="item.user_name+'-'+item.role_name"
            :value="item.uid"
          ></el-option>
          </template>
        </el-select>
      </el-form-item>
      <el-form-item label="手机号码" class="flex-50" prop="user_mobile">
        <el-input v-model="dataInfo.user_mobile"></el-input>
      </el-form-item>
      <el-form-item label="电子邮箱" class="flex-50" prop="user_email">
        <el-input v-model="dataInfo.user_email"></el-input>
      </el-form-item>
      <el-form-item label="固定电话" class="flex-50" prop="user_tel">
        <el-input v-model="dataInfo.user_tel"></el-input>
      </el-form-item>

      <el-form-item label="用户头像" class="flex-50" prop="tpid">
        <cmsPicture :picurl="picUrl" :showcancel="showCancel" :showreset="showReset" @btnClick="openPicDiag()" @picCancel="picCancel()" @picReset="picReset()">
          
        </cmsPicture>
      </el-form-item>
      <el-form-item label="用户备注" class="flex-50" prop="user_des">
        <el-input type="textarea" :rows="6" v-model="dataInfo.user_des"></el-input>
      </el-form-item>
      
      <el-form-item label="创建时间" class="flex-50" prop="create_time">
        <el-input :disabled="true" v-model="dataInfo.create_time"></el-input>
      </el-form-item>
      <el-form-item label="账户余额" class="flex-50" prop="account_balances">
        <el-input :disabled="true" v-model="dataInfo.account_balances">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      <el-form-item label="所在地区" class="flex-50" prop="user_region">
        <el-input v-model="dataInfo.user_region"></el-input>
      </el-form-item>
      <el-form-item label="详细地址" class="flex-50" prop="user_address">
        <el-input v-model="dataInfo.user_address"></el-input>
      </el-form-item>
      <el-form-item label="公司名称" class="flex-100" prop="user_corporation">
        <el-input v-model="dataInfo.user_corporation"></el-input>
      </el-form-item>
      <el-form-item label="主要行业应用" class="flex-100" prop="corp_major">
        <el-input v-model="dataInfo.corp_major"></el-input>
      </el-form-item>
      <el-form-item label="公司规模" class="flex-50" prop="corp_size">
        <el-radio-group v-model="dataInfo.corp_size">
          <el-radio :label="'0'">100人以下</el-radio>
          <el-radio :label="'1'">100-300人</el-radio>
          <el-radio :label="'2'">300-500人</el-radio>
          <el-radio :label="'3'">500人以上</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="营业年限" class="flex-50" prop="corp_opetating_period">
        <el-radio-group v-model="dataInfo.corp_opetating_period">
          <el-radio :label="'0'">0-3年以内</el-radio>
          <el-radio :label="'1'">1-5年以内</el-radio>
          <el-radio :label="'2'">5-10年以内</el-radio>
          <el-radio :label="'3'">10年以上</el-radio>
        </el-radio-group>
      </el-form-item>
      
      <el-form-item label="公司备注" class="flex-100" prop="corp_des">
        <el-input type="textarea" :rows="7" v-model="dataInfo.corp_des"></el-input>
      </el-form-item>
      <!-- 按钮组 -->
      <div class="form-footer">
        <el-button type="primary" @click="update()">
          修改
        </el-button>
        <el-button type="info" @click="$router.go(-1)">
          放弃修改
        </el-button>
        <el-button type="info" @click="reset">重置</el-button>
        <span class="gray">
          选择“修改”按钮，提交修改后将跳转到对应的列表页</span
        >
      </div>
    </el-form>

    <!-- 图片选择 -->
    <el-dialog title="图片选择" :visible.sync="picDialog">
      <cmsPictureList :total="total" :tableData="tableData" @picClick="picClick" @change="getPages"></cmsPictureList>
    </el-dialog>

  </section>
</template>
<script>
import va from "@/rules";
import formMixns from "@/mixins/form";
import listMixins from "@/mixins/list";

export default {
  mixins: [formMixns,listMixins], //普通表单变量
  data() {
    let self=this;
    function password() {
      return {
        validator: (rule, value, callback) => {
          if (value === "") {
            callback();
          } else {
            if (self.dataInfo.confirmPassword !== "") {
              self.$refs.form.validateField("confirmPassword");
            }
            callback();
          }
        },
        trigger: "blur"
      };
    }

    function confirmPassword() {
      return {
        validator: (rule, value, callback) => {
          if (value === "" || value === undefined) {
            callback();
          } else if (value !== self.dataInfo.user_pwd) {
            callback(new Error("前后密码不一致"));
          } else {
            callback();
          }
        },
        trigger: "blur"
      };
    }

    let required = va.required("此项必填");
    let number = va.number("只能输入数字");
    let email = va.email("请输入正确的邮箱地址");
    let validateCode = va.validateCode("用户名已存在", "User/IsExist", this.$route.query.id);
    let tel = va.tel("请输入正确的固定电话");
    let mobile = va.mobile("请输入正确的手机号");

    return {
      rules: {
        //校验规则
        user_name: [required, validateCode],
        user_email: [email],
        user_pwd: [password()],
        confirmPassword: [confirmPassword()],
        user_tel: [tel],
        user_mobile: [required, mobile],
        rid:[required],
        user_status:[required]
      },
      roles: [],
      users: [],
      isadmin: false,
      params:{
        pageNo:'1',
        pageSize:'10'
      },
      picDialog:false,
      picUrl:'',
      oldPic:{
        tpid:'',//记录修改前的tpid
        pic_url:''//记录修改前的pic_url
      },
      showCancel:false,
      showReset:false
    };
  },
  methods: {
    update() {
      this.updateDataInfo("User/Update", this.dataInfo, "/user/list");
    },
    getDataInfo(id) {
      //重写获取表单数据
      let self=this;
      this.$api
        .post("User/Detail", { id: id })
        .then(res => {
          this.loading = true;
          if (res.status === 200) {
            this.loading = false;
            this.dataInfo = res.data.Data;
            if(this.dataInfo.create_time){
              self.dataInfo.create_time=self.dataInfo.create_time.replace('T',' ')
            }
          }
        })
        .catch(err => {
          this.loading = false;
        });
    },
    reset() {
      this.getDataInfo(this.id);
    },
    loadOption(){
      this.$api.post("Role")
      .then(res => {
        if (res.status === 200) {
          this.roles = res.data.Data;
        }
      })
      .catch(err => {
        console.log(err);
      });

      this.$api.post("User",{rid:'1,2'})
      .then(res => {
        if (res.status === 200) {
          this.users = res.data.Data.list;
        }
      })
      .catch(err => {
        console.log(err);
      });
    },
    openPicDiag(){
      this.picDialog=true
    },
    picClick(id,url){
      this.dataInfo.tpid=id;
      this.picUrl=url;
      if(this.dataInfo.tpid!==this.oldPic.tpid){
        this.showCancel=true
      }
      else{
        this.showCancel=false
      }
      this.showReset=true
    },
    picCancel(){
      this.dataInfo.tpid=this.oldPic.tpid
      this.picUrl=this.oldPic.pic_url
      this.showCancel=false
      this.showReset=true
    },
    picReset(){
      this.dataInfo.tpid=null;
      this.picUrl='';
      this.showCancel=false;
      this.showReset=false;
    }
  },
  created() {
    this.loadOption();
    this.getDataInfo(this.id);
    this.isadmin = this.$isAdmin();

    //获取图片
    this.params.uid = this.$store.state.userInfo.id;
    this.initTableData("Picture/PagedView", this.params);
  }
};
</script>
